/**
 * App entry point (mirrored for Figma export + app build).
 */
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import App from "./app-shell/App.tsx";
import ErrorBoundary from "./app-shell/ErrorBoundary.tsx";
import "./styles/index.css";

console.log("🚀 main.tsx loading...");

declare global {
  interface Window {
    __pendingDeepLink?: string;
  }
}

const isNativePlatform =
  typeof Capacitor.isNativePlatform === "function" ? Capacitor.isNativePlatform() : Capacitor.getPlatform() !== "web";

if (isNativePlatform) {
  (async () => {
    await CapacitorApp.addListener("appUrlOpen", ({ url }) => {
      window.__pendingDeepLink = url;
    });
  })();

  CapacitorApp.getLaunchUrl()
    .then((result) => {
      if (result?.url) {
        window.__pendingDeepLink = result.url;
      }
    })
    .catch((error) => {
      console.warn("Failed to read launch url (early)", error);
    });
}

console.log("🎯 Creating React root...");

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

console.log("✅ React root created");

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed", error);
    });
  });
}


